/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MailboxItemLinkDTO } from './MailboxItemLinkDTO';
import {
    MailboxItemLinkDTOFromJSON,
    MailboxItemLinkDTOFromJSONTyped,
    MailboxItemLinkDTOToJSON,
    MailboxItemLinkDTOToJSONTyped,
} from './MailboxItemLinkDTO';

/**
 * 
 * @export
 * @interface MailboxUpdateLinksDTO
 */
export interface MailboxUpdateLinksDTO {
    /**
     * 
     * @type {Array<MailboxItemLinkDTO>}
     * @memberof MailboxUpdateLinksDTO
     */
    Links?: Array<MailboxItemLinkDTO> | null;
}

/**
 * Check if a given object implements the MailboxUpdateLinksDTO interface.
 */
export function instanceOfMailboxUpdateLinksDTO(value: object): value is MailboxUpdateLinksDTO {
    return true;
}

export function MailboxUpdateLinksDTOFromJSON(json: any): MailboxUpdateLinksDTO {
    return MailboxUpdateLinksDTOFromJSONTyped(json, false);
}

export function MailboxUpdateLinksDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxUpdateLinksDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'Links': json['Links'] == null ? undefined : ((json['Links'] as Array<any>).map(MailboxItemLinkDTOFromJSON)),
    };
}

export function MailboxUpdateLinksDTOToJSON(json: any): MailboxUpdateLinksDTO {
    return MailboxUpdateLinksDTOToJSONTyped(json, false);
}

export function MailboxUpdateLinksDTOToJSONTyped(value?: MailboxUpdateLinksDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Links': value['Links'] == null ? undefined : ((value['Links'] as Array<any>).map(MailboxItemLinkDTOToJSON)),
    };
}

